import { useMutation } from 'react-query'
import { verificationService } from 'src/services/verification.service'

export const useCaptchaVerification = () => {
  return useMutation((token: string) => verificationService.verifyCaptcha(token))
}
